import React from 'react';

//PACKS
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

//Forms
import LoginForm from '../../../../containers/forms/login/Login';

class Login extends React.Component {
    
    render(){
        
        const dados = {
            idevento: this.props.idevento?this.props.idevento:14,
            idpromotora: this.props.idpromotora?this.props.idpromotora: 68,
            idcategoria: 1
        }

        return (
            <LoginForm {...dados} />
        )
    }
}

const mapStateToProps = (state) => {
    return {        
        pendingTasks: state.pendingTasks,
        loginResult: state.loginValidaReducer
    }
}

export default connect(mapStateToProps)(withRouter(Login));